<template>
  <b-modal
    @hide="closeModel"
    size="xl"
    :id="`assign-driver-model-${trip._id}`"
    :modal-class="['change-modal-container']"
  >
    <base-spinner v-if="data_loading" />
    <div v-else class="p-3">
      <div>
        <div>
          <b-alert :show="error && error.length ? true : false" variant="danger">
            <div v-if="Array.isArray(error)">
              <div
                class="d-flex flex-column my-1"
                v-for="(error_text, index) in error"
                :key="index"
              >
                {{ error_text }}
              </div>
            </div>
            <div v-else>
              <div v-html="error || '&nbsp;'"></div>
            </div>
          </b-alert>

          <div class="d-flex justify-content-between align-items-center my-4">
            <div class="assign-section-title">{{ $t('assign-driver') }}</div>
            <img
              :src="require('@/assets/images/icons/close-icon.svg')"
              alt=""
              class="cursor-pointer"
              @click="closeModel()"
            />
          </div>
          <hr />
          <div class="block-sm" style="margin-bottom: 20px">
            <ChangeDriverList
              :trip="trip"
              @selectDriver="selectDriver"
              :selectedDriverId="selectedDriverId"
              :selectedVehicleId="selectedVehicleId"
              :isMainDriver="isMainDriver"
              :isReassign="isReassign"
            />
          </div>
        </div>
        <div class="modal-action-container d-flex align-items-center justify-content-end">
          <div>
            <base-button
              variant="primary"
              :loading="loading"
              id="change-vehicle-search-btn-save"
              @click="submit"
              :disabled="!selectedDriverId"
            >
              {{ isReassign ? $t('reassign') : $t('assign') }}
            </base-button>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ChangeDriverList from './ChangeDriverList.vue'

export default {
  name: 'assign-driver-model',
  components: { ChangeDriverList },
  props: ['trip', 'selectedVehicleId', 'isMainDriver', 'isReassign'],
  emits: ['selectedDriver'],
  data() {
    return {
      data_loading: false,
      loading: false,
      error: null,
      selectedDriverId: null,
      selectedDriver: null,
    }
  },
  methods: {
    selectDriver(item) {
      this.selectedDriverId = (item && item.driverId) || null
      this.selectedDriver = item ? item : null
    },
    submit() {
      this.$emit('selectedDriver', this.selectedDriver)
      this.closeModel()
    },

    closeModel() {
      this.error = null
      this.$bvModal.hide(`assign-driver-model-${this.trip._id}`)
    },
  },
  i18n: {
    messages: {
      en: require('@/services/i18n/locales/en/operations.json'),
      ar: require('@/services/i18n/locales/ar/operations.json'),
    },
  },
}
</script>
